import { Component, Input } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { WebEnvironmentService } from '@app/shared/services/web-environment.service';

@Component({
  selector: 'dgx-profile-empty-state',
  templateUrl: './profile-empty-state.component.html',
  styleUrls: ['./profile-empty-state.component.scss'],
})
export class ProfileEmptyState {
  @Input() public title: string;
  @Input() public description: string;
  @Input() public helpText: string; // optional

  public i18n = this.translateService.instant(['Core_Empty_Image_Alt']);

  constructor(
    private translateService: TranslateService,
    private webEnvironmentService: WebEnvironmentService
  ) {}

  public get emptyImageUrl(): string {
    return this.webEnvironmentService.getBlobUrl(
      '/content/img/emptystate/profile-settings.svg',
      true
    );
  }
}
